import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import store from "../store";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";
import { QuestionRoutes } from "./question.router";
import { DashboardRoutes } from "./dashboard.router";
import { InterviewRoutes } from "./interview.router";

Vue.use(VueRouter);

const routes = [
    ////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        path: "/common/kcp/cert/request",
        component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
        props: true,
    },
    {
        path: "/common/kcp/cert/response",
        component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
        props: true,
    },
    {
        // 가이드
        path: "/guide",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/Guide.vue"),
        props: true,
    },
    {
        // 로그인
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
        props: true,
    },
    {
        // 비밀번호 찾기
        path: "/login/find-password",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
        props: true,
    },
    {
        // 아이디 찾기
        path: "/login/find-id",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
        props: true,
    },
    {
        // 회원가입 - 유형
        path: "/join",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/JoinTypePage.vue"),
        props: true,
    },
    {
        // 회원가입 - 양식
        path: "/join/form",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
        props: true,
    },
    {
        // 회원가입 완료
        path: "/join/complete",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
        props: true,
    },
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    {
        // Info
        path: "/about",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/sub/AboutPage.vue"),
        props: true,
    },
    {
        // Agent
        path: "/service",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/sub/ServicePage.vue"),
        props: true,
    },
    {
        // Bridge 목록
        path: "/programs",
        component: () => import(/* webpackChunkName: "programs" */ "../pages/client/programs/ProgramListPage.vue"),
        props: true,
    },
    {
        // Bridge 상세
        path: "/programs/:_program",
        component: () => import(/* webpackChunkName: "programs" */ "../pages/client/programs/ProgramViewPage.vue"),
        props: true,
    },
    {
        // Bridge 참여
        path: "/programs/:_program/dashboard",
        component: () => import(/* webpackChunkName: "programs" */ "../pages/client/programs/ProgramDashboardPage.vue"),
        props: true,
    },
    {
        // Career
        path: "/lectures",
        component: () => import(/* webpackChunkName: "lectures" */ "../pages/client/lectures/LectureMainPage.vue"),
        props: true,
    },
    {
        // Career
        path: "/lectures/:_lecture",
        component: () => import(/* webpackChunkName: "lectures" */ "../pages/client/lectures/LectureViewPage.vue"),
        props: true,
    },
    {
        // 고객센터
        path: "/center",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 고객센터 - 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 고객센터 - 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 고객센터 - 자주묻는질문
        path: "/center/faqs",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 고객센터 - 문의하기
        path: "/center/inquiry",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/inquiry.vue"),
        props: true,
    },
    {
        // 서비스이용약관
        path: "/service-policy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/ServicePolicyPage.vue"),
        props: true,
    },
    {
        // 개인정보처리방침
        path: "/privacy-policy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/PrivacyPolicyPage.vue"),
        props: true,
    },
    {
        // 문의 및 제휴
        path: "/form/inquiry-partner",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
        props: true,
    },
    {
        // Recruit 목록
        path: "/search",
        component: () => import(/* webpackChunkName: "recruitments" */ "../pages/client/recruitments/RecruitmentSearchPage.vue"),
        props: true,
    },
    {
        // Recruit 목록
        path: "/recruitments",
        component: () => import(/* webpackChunkName: "recruitments" */ "../pages/client/recruitments/RecruitmentListPage.vue"),
        props: true,
    },
    {
        // Recruit 상세
        path: "/recruitments/:_recruitment",
        component: () => import(/* webpackChunkName: "recruitments" */ "../pages/client/recruitments/RecruitmentViewPage.vue"),
        props: true,
    },
    {
        // 기업 상세
        path: "/companies/:_company",
        component: () => import(/* webpackChunkName: "companies" */ "../pages/client/companies/CompanyViewPage.vue"),
        props: true,
    },
    {
        // 미팅 상세
        path: "/meetings/:_meeting",
        component: () => import(/* webpackChunkName: "recruitments" */ "../pages/client/meetings/MeetingViewPage.vue"),
        props: true,
    },

    ////////////////////////////////////////////////////////////////////////////
    // 나이스페이
    ////////////////////////////////////////////////////////////////////////////
    {
        // 나이스페이 호출
        path: "/plugins/nicepayments/nicepay/request",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/plugins/nicepayments/nicepay/request.vue"),
        props: true,
    },
    {
        // 네이스페이 결과
        path: "/plugins/nicepayments/nicepay/response",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/plugins/nicepayments/nicepay/response.vue"),
        props: true,
    },

    ////////////////////////////////////////////////////////////////////////////
    // 대시보드 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////
    ...DashboardRoutes,

    ////////////////////////////////////////////////////////////////////////////
    // 인터뷰 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////
    ...InterviewRoutes,

    ////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 회원등급
        path: "/console/withdrawn-users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 포인트 - 포인트 내역
        path: "/console/user-points",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user-points/UserPointList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 포인트 - 무통장입금 거래
        path: "/console/user-point-orders",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user-points/PointOrderList.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 포인트 - 무통장입금 거래
        path: "/console/account-order-forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/AccountOrderList.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 포인트 - 무통장입금 계좌
        path: "/console/bank",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/BankView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Recruit - 공고목록
        path: "/console/recruitment/list",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/recruitment/RecruitmentListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Recruit - 공고통계
        path: "/console/recruitment/list/:_recruitment/statistics",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/recruitment/RecruitmentStatisticsPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Bridge - 프로그램 목록
        path: "/console/expo/programs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/expo/ExpoProgramList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Career - 메인설정
        path: "/console/lecture/main",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lecture/LectureMainPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Career - 카테고리
        path: "/console/lecture/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lecture/LectureCategoryList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Career - 메인설정
        path: "/console/lecture/list",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lecture/LectureListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 채팅상담 - 상담내역 목록
        path: "/console/chat/rooms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/chat/ChatRoomList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 채팅상담 - 상담내역 상세
        path: "/console/chat/rooms/:_room",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/chat/ChatRoomView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 채팅상담 - 프롬프트
        path: "/console/chat/prompts",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/chat/ChatPromptList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 채팅상담 - 안내문구
        path: "/console/chat/prompt-alerts",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/chat/ChatPromptAlerts.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - OpenAI
        path: "/console/plugins/open-ai",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/plugins/PluginOpenAI.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 고객센터 - 1:1 문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 고객센터 - 서비스 문의
        path: "/console/center/service-inquiry-forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/ServiceInquiryList.vue"),
        scope: ["console"],
    },
    {
        // 관리자 - 고객센터 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 고객센터 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
        scope: ["console"],
    },

    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 해시태그
        path: "/console/hash-tags",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/HashTagList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 해시태그
        path: "/console/hash-tags",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/HashTagList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Big Data - 방문/회원
        path: "/console/statistics/main",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/statistics/StatisticsMainPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Big Data - 채용 플랫폼
        path: "/console/statistics/recruitment",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/statistics/StatisticsRecruitmentPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - Big Data - 채용 플랫폼
        path: "/console/statistics/reports",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/statistics/StatisticsReportList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
        scope: ["console"],
    },

    //////////////////////////////////////////////////////////////////////////////////////////
    // developer documents
    //////////////////////////////////////////////////////////////////////////////////////////
    {
        path: "/developer/converter",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/converter.vue"),
        props: true,
    },
    {
        path: "/developer/auth/login-logout",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/auth/login-logout.vue"),
        props: true,
    },
    {
        path: "/developer/me/points/my-point",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/me/points/my-point.vue"),
        props: true,
    },
    {
        path: "/developer/me/points/charge",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/me/points/charge.vue"),
        props: true,
    },
    {
        path: "/developer/me/points/history",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/me/points/history.vue"),
        props: true,
    },
    {
        path: "/developer/me/points/use",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/me/points/use.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    try {
        const accessToken = sessionStorage.getItem("accessToken");
        axios.defaults.headers.common["Authorization"] = !!accessToken ? `Bearer ${accessToken}` : "";

        const session = sessionStorage.getItem("session");
        if (session) axios.defaults.headers.common["session"] = session;
        else delete axios.defaults.headers.common["session"];

        const payload = accessToken ? JSON.parse(atob(accessToken.split(".")[1])) || {} : {};
        const route = routes.find((route) => route.path == to.path);
        if (route?.scope) {
            if (!accessToken) throw new Error("로그인 후 이용가능합니다");

            const { scope = [] } = payload;
            if (!scope.some((scope) => route.scope.includes(scope))) throw new Error("접근권한이 없습니다");

            next();
        } else if (route?.userTypes) {
            if (!accessToken) throw new Error("로그인 후 이용가능합니다");

            const { userType } = payload;
            if (!route.userTypes.includes(userType)) throw new Error("접근권한이 없습니다");

            next();
        } else next();
    } catch (error) {
        alert(error.message);
        let path;
        if (from.path != "/") path = routes.find((route) => route.path == from.path);
        if (!path) {
            path = ["/dashboard", "/console"].find((path) => to.path.includes(path)) || "/";
        }
        window.location.href = path;
    }
});

router.afterEach((to, from) => {
    store.dispatch("getSession", { referrer: document.referrer });
});

export default router;
